var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-loading-overlay",class:[
    'gc-loading-overlay--' + _vm.normalizedMode,
    {
      'is-compact': _vm.compact,
      'is-clear': _vm.clear
    }
  ],style:(_vm.overlayStyle),attrs:{"aria-live":"polite","aria-busy":"true"}},[_c('Loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }